import React, { useState } from 'react';

import { useTranslate, useValidation } from '../../../../../../../hooks';

import { AutoComplete, Button, CustomRadioGroup, RadioButton, TextInput, ToggleWithLabel2 } from '../../../../../../../components';
import { LoadingButton } from '../../../../../../../components/buttons';
import CloseIcon from '@mui/icons-material/Close';

import { addNoticePeriodAutomation, editOvertime } from '../validations';
import { colors } from '../../../../../../../helpers/colors';
import { Box, ButtonBase, Typography } from '@mui/material';
import _ from 'lodash';

function EditNoticePeriodAutomationConfig({ toggleModal, customHandler, seletedData, isEditing }) {
  const { translate } = useTranslate();

  const leaveItems = [
    { id: 30, name: '30 Days' },
    { id: 0, name: 'Calendar Days' },
    { id: 365, name: 'Yearly' },
  ];
  const [form, setForm] = useState({
    id: seletedData?.id,
    days: seletedData?.days,
    fnfDeduction: seletedData?.fnd_deduction,
    name: seletedData?.name,
    salaryWorkingDays: {
      id: leaveItems?.find((item) => item?.id == seletedData?.notice_period_salary_working_days)?.id,
      label: leaveItems?.find((item) => item?.id == seletedData?.notice_period_salary_working_days)?.name
    },
  });

  const { errors, validate } = useValidation(addNoticePeriodAutomation, {
    name: form?.name,
    days: form?.days,
  });

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    if (await validate()) {
      customHandler(form);
    }
  };

  const handleChange = ({ key, value }) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  return (
    <div className="w-[450px] h-auto p-5 bg-white rounded-md app-modal base-modal">
      <span className="flex items-center gap-x-2 mb-4 h-[26px]">
        <span className="flex gap-x-1">
          <p className="welcome-text font-bold">{translate('Edit')}</p>
          <p className="welcome-text2 font-bold">{translate('Notice Period Automation Configuration')}</p>
        </span>
        <div className="ml-auto cursor-pointer" onClick={toggleModal}>
          <CloseIcon className="text-gray-400" />
        </div>
      </span>
      <form
        onSubmit={handleSaveEdit}
        className="flex flex-col gap-4 max-h-[450px] w-[100%] overflow-auto pt-2"
      >
        <Box>
          <TextInput
            fullWidth
            inputProps={{ className: '!p-[13.5px]' }}
            label={translate('Name')}
            error={errors?.name}
            helperText={errors?.name}
            value={form?.name}
            onChange={(e) => {
              handleChange({
                key: `name`,
                value: e?.target?.value,
              });
            }}
          />
        </Box>
        <Box>
          <TextInput
            fullWidth
            type='number'
            error={errors?.days}
            helperText={errors?.days}
            defaultValue={form?.days}
            label={translate('Days')}
            onChange={(e) => {
              let value = parseFloat(e?.target?.value);
              if (!isNaN(value)) {
                value = parseFloat(value.toFixed(1));
                if (value % 1 === 0) {
                  value = parseFloat(value.toFixed(0));
                }
              }
              handleChange({
                key: `days`,
                value: value,
              });
            }}
          />
        </Box>
        {/* <div className="flex flex-row">
                      <Checkbox
                        checked={form?.name}
                        onChange={(e) =>
                          handleChange({
                            key: 'fnf_deduction',
                            value: e.target.checked, // set 0 if checked, null if unchecked
                          })
                        }
                      >
                        {translate('Deduct Automatically in FNF')}
                      </Checkbox>
                    </div> */}
        <ToggleWithLabel2
          handleChange={(e) => {
            handleChange({
              key: 'fnfDeduction',
              value: e?.target?.checked,
            });
          }}
          isActive={form?.fnfDeduction}
          label={translate('Deduct Automatically in FNF')}
        />
        <AutoComplete
          label={translate('Salary Working Days')}
          data={leaveItems?.map((item, index) => ({
            id: item?.id,
            label: item?.name,
          }))}
          onChange={(option) => {
            handleChange({ key: 'salaryWorkingDays', value: option });
          }}
          className={`w-full h-[56px] border-[${colors?.lightgrey}]`}
          inputProps={{
            fullWidth: true,
          }}
          value={
            form?.salaryWorkingDays
          }
        />
        <div className="flex justify-end gap-4 mt-auto">
          <Button
            className={`outline-btn min-w-[75px] rounded-md`}
            onClick={toggleModal}
          >
            {translate('Cancel')}
          </Button>
          <LoadingButton
            className="primary-btn min-w-[75px] rounded-md"
            type="submit"
            isLoading={isEditing}
          >
            {translate('Save')}
          </LoadingButton>
        </div>
      </form>
    </div>
  );
}

export default EditNoticePeriodAutomationConfig;
